import React from 'react';
import { styles } from './CustomerCollectInformation.css';
import { StoreInformation } from './StoreInformation';
import {
  BaseContentSection,
  ShipmentStatus,
  StoreInformationType,
} from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';
import { ImportantTextBlock } from '../ImportantTextBlock';

export type CustomerCollectInformationProps = {
  store: StoreInformationType;
  status: ShipmentStatus;
  importantText?: BaseContentSection;
  onStoreDirectionSearch: (storeName: string) => void;
};

export const CustomerCollectInformation = ({
  store,
  status,
  importantText,
  onStoreDirectionSearch,
}: CustomerCollectInformationProps) => {
  return (
    <div data-testid="order-tracking-customerCollect-information" className={styles.container}>
      <div className={styles.storeInformation}>
        <div role="paragraph">{store.name}</div>
        <div role="paragraph">{store.addressLine1}</div>
        <div role="paragraph">
          {store.suburb ? `${store.suburb},` : ''} {store.state ? `${store.state},` : ''} {store.postcode}
        </div>
      </div>
      {status == 'AwaitingCollection' ? (
        <StoreInformation store={store} onDirectionSearch={onStoreDirectionSearch} />
      ) : null}
      {importantText ? <ImportantTextBlock {...importantText} /> : null}
    </div>
  );
};
